import 'globals';

const prepareYouTubeTracking = function (wrapper) {
    var deferred = $.Deferred(), prepareAttribute = null;
    $.each(wrapper.attributes, function() {
        if (this.name.indexOf('data-gtm-yt') !== -1) {
            prepareAttribute = this.name;
        }
    });

    if (prepareAttribute !== null) {
        $(wrapper).attr(prepareAttribute, '');
    }
    return deferred;
};

const loadYouTubeIframeAPI = function (loadOnce) {
    if ((loadOnce && $('.gtm-api-include').length === 0) || loadOnce === false ) {
        const iframeAPI = document.createElement('script');
        iframeAPI.type = 'text/javascript';
        iframeAPI.src = 'https://www.youtube.com/iframe_api';
        iframeAPI.classList = 'gtm-api-include';
        $('body').append(iframeAPI);
    }
};

(function(PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        new LazyEmbed({
            elements: '[data-lazyembed="video"]',
            overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.video.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy),
            onClick: function (wrapper) {
                prepareYouTubeTracking(wrapper).done(loadYouTubeIframeAPI(false))
            }
        });
        new LazyEmbed({
            elements: '[data-lazyembed="map"]',
            overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.map.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy)
        });
    });
})(window.PageLoadedQueue);
